export default __webpack_public_path__ + "images/multilang-intro-step-1.fdaf701df3d664c808819ce2a9d4ad4d.png";